export default __webpack_public_path__ + "43b44137d86f69d02928a298de7ea29e.png";